import { FieldProps } from 'components/Field'
import { useField } from 'formik'
import React from 'react'
import styled, { css } from 'styled-components'
import { SelectField, SelectFieldProps } from 'components/FormFields'
import { FormikFieldStatus } from '../../Formik.field.status'

export const formikSelectStyles = css``

const FormikSelectView = styled.div`
	${formikSelectStyles}
`

export type FormikSelectProps = Pick<SelectFieldProps, 'defaultTxt' | 'options'> & {
	name: string
	config: FieldProps
}
export const FormikSelect = ({ name, config, ...selectProps }: FormikSelectProps) => {
	const [{ value }, { touched }, { setValue, setTouched }] = useField({ name })

	return (
		<FormikSelectView>
			<SelectField
				{...config}
				{...selectProps}
				onSelect={(val: any) => {
					setValue(val)
					if (!touched) setTouched(true)
				}}
				value={value}
			/>
			<FormikFieldStatus name={name} />
		</FormikSelectView>
	)
}
